export const VOLUME_DISCOUNT_MULTI_MARKET_INFORMATIONAL_PAGE_URL = '/volume-discount';
export const DEFAULT_VOLUME_DISCOUNT_GROUP = 'volume_discount_default';
export const VOLUME_DISCOUNT_MIN_TIER = 3;
